<template>
  <article class="layout-section -bg-primary">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.collaborations.title }}</h2>
    </div>

    <section class="layout-grid">
      <div v-for="entry in wp.collaborations.entries" :key="entry.title" class="card -bigger">
        <h4 class="card__uptitle">{{ entry.sector }}</h4>
        <h3 class="card__title">{{ entry.title }}</h3>
        <div class="rte" v-html="entry.content" />
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutCollaborationsIndex',
  inject: ['wp']
}
</script>
